import { styled } from 'dripsy';
import React from 'react';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';

import {
  BaseText,
  Button,
  ButtonStyleEnum,
  Image,
  // LanguageMenu,
} from '@components';
import type { IAuthLayoutProps } from './AuthLayout';

const Container = styled(View)({
  flexDirection: 'row',
  flex: 1,
  backgroundColor: '$background0',
});

const ContentContainer = styled(View)({
  flex: 2,
});

const ChildrenContainer = styled(View)({
  flex: 1,
});

const MediaContainer = styled(View)({
  flex: 1,
  display: ['none', 'flex'],
  justifyContent: 'flex-end',
  alignItems: 'center',
});

const BackgroundImage = styled(Image)({
  position: 'absolute',
  width: '100%',
  height: '100%',
});

const Title = styled(BaseText)({
  variant: 'text.xxbig',
  color: '$background0',
  fontWeight: 'semi',
});

const Text = styled(BaseText)({
  variant: 'text.medium',
  color: '$background40',
});

const TextContainer = styled(View)({
  width: '80%',
  bottom: '$14',
});

const HeaderContainer = styled(View)({
  width: '100%',
  flexDirection: 'row',
  height: 78,
  pl: ['$6', '$5'],
  pr: ['$6', '$14'],
  alignItems: 'center',
  justifyContent: 'space-between',
});

const HeaderLanguageContainer = styled(View)({});

const HeaderButtonContainer = styled(View)({
  flexDirection: 'row',
  alignItems: 'center',
});

const HeaderButton = styled(Button)({
  minWidth: 125,
});

const HeaderButtonSideText = styled(BaseText)({
  display: ['none', 'flex'],
  color: '$heading600',
  variant: 'text.medium',
  mr: '$5',
});

export function AuthLayout({
  children,
  onPressHeaderButton,
  headerButtonSideText,
  headerButtonText,
  isAuthorized = false,
}: IAuthLayoutProps) {
  const { t } = useTranslation();

  const isHeaderButtonShown = !!onPressHeaderButton;
  const isHeaderButtonSideTextShown = !!headerButtonSideText;

  return (
    <Container>
      <MediaContainer>
        {isAuthorized ? (
          <BackgroundImage
            source={require('../../../assets/images/personalization.jpg')}
          />
        ) : (
          <BackgroundImage
            source={require('../../../assets/images/auth.jpg')}
          />
        )}
        <TextContainer>
          <Title>{t('common.authLayout.title')}</Title>
          <Text>{t('common.authLayout.text')}</Text>
        </TextContainer>
      </MediaContainer>
      <ContentContainer>
        <HeaderContainer>
          <HeaderLanguageContainer>
            {/* <LanguageMenu /> */}
          </HeaderLanguageContainer>
          <HeaderButtonContainer>
            {isHeaderButtonSideTextShown && (
              <View>
                <HeaderButtonSideText>
                  {headerButtonSideText}
                </HeaderButtonSideText>
              </View>
            )}
            {isHeaderButtonShown && (
              <View>
                <HeaderButton
                  onPress={onPressHeaderButton}
                  buttonStyle={ButtonStyleEnum.Outline}
                >
                  {headerButtonText}
                </HeaderButton>
              </View>
            )}
          </HeaderButtonContainer>
        </HeaderContainer>
        <ChildrenContainer>{children}</ChildrenContainer>
      </ContentContainer>
    </Container>
  );
}
